import { StationEvent, StationEventType } from './models/stationEvent';
import Service from './Service';

class StationEventService {
  private static URL_BASE = process.env.REACT_APP_URL_API;

  static getStationEvents(
    stationId: number,
    params?: {
      type?: StationEventType;
      lockId?: number;
      limit?: number;
      offset?: number;
    },
  ): Promise<{ events: StationEvent[]; total: number }> {
    const searchParams = new URLSearchParams();
    if (params?.type) searchParams.set('type', params.type);
    if (params?.lockId) searchParams.set('lockId', String(params.lockId));
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.offset) searchParams.set('offset', String(params.offset));
    const query = searchParams.toString();
    return Service.get(
      `${this.URL_BASE}/station-events/station/${stationId}${query ? `?${query}` : ''}`,
    );
  }
}

export default StationEventService;
